module.exports = __webpack_public_path__ + "img/preparatoria.be2864ef.svg";